import toReactComponent from 'svgr.macro'
import moize from 'moize'

const getSvgIcons = () => {
  return toReactComponent('./icons/*.svg')
}

const icons = moize(getSvgIcons)

export default icons
